export const TIME_INTERVAL = 30;
export const LAYOUT_INITIAL_OFFSET = 56;
export const LAYOUT_OFFSET = import.meta.env.VITE_THEME_CONFIG === 'colinor' ? 56 : 120;
